import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Everything that ends up as an API parameter of the project list — search,
// page, size, sorting, state filter, current folder — is a URL param now, read
// through `useProjectMenuListViewControl`. What is left here is the page size
// default, which is a user preference rather than a parameter of a given list.
export const useProjectMenuStore = create(
  persist(
    (set) => ({
      // Persisted so a fresh /project without `?size=` opens with the size the
      // user last picked.
      projectListPageSize: 15,
      setProjectListPageSize: (projectListPageSize) =>
        set({ projectListPageSize })
    }),

    {
      name: 'project-menu-store',
      partialize: (state) => ({
        projectListPageSize: state.projectListPageSize
      })
    }
  )
)
